import type {ReactAction} from '@netx/core/bootstrap';
import {faKey} from '@fortawesome/pro-solid-svg-icons';
import {dispatcher} from '@netx/core-next/instance/dispatcher';
import {UserActionLabel} from '../locales';
import {canResetPassword} from '../enablers';
import {USER_EVENT} from './constants';
import {useCurrentUser} from '../store/currentUser';

export const userActionChangePassword = (
	params?: Partial<ReactAction>,
): ReactAction => ({
	name: 'user-change-password',
	cb: () => {
		const {login} = useCurrentUser.getState().user;
		dispatcher.trigger(USER_EVENT.RESET_PASSWORD, login);
	},
	enableTest: () => canResetPassword(useCurrentUser.getState().user),
	icon: faKey,
	get label() {
		return UserActionLabel.RESET_PASSWORD;
	},
	...params,
});

export default userActionChangePassword;
